// extracted by mini-css-extract-plugin
export default {"main_css_us":"SubHeader_main_css_us__+W4BZ","main_css_jp":"SubHeader_main_css_jp__ETSRE"};